/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
  deleteTradingKeyword,
  getTradingKeywords,
  saveTradingKeywords,
} from 'store/modules/monitoring_store/actions';
import { MonitoringState, TradingKeywordTypes } from 'store/modules/monitoring_store/types';
import { Link } from 'react-router-dom';
import Loader from 'components/atoms/loader';
import TradingKeywordItem from 'components/atoms/trading_keyword_item';
import Switch from 'components/atoms/switch';
import Checkbox from 'components/atoms/checkbox';
import MonitoringPushModal from 'components/atoms/monitoring_push_modal';
import SquareLoader from 'components/atoms/square_loader';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import {
  getMonitoringPreferences,
  updateMonitoringPreferences,
} from 'store/modules/monitoring_preferences_store/actions';
import {
  MonitoringPreferenceData,
  MonitoringPreferencesState,
} from 'store/modules/monitoring_preferences_store/types';
import companyId from 'services/company_id';
import { Container } from './styles';

const MonitoringConfiguration: React.FC = () => {
  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { monitoring, request } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );

  const { monitoring_preferences } = useSelector<ApplicationState, MonitoringPreferencesState>(
    (state) => state.storage.monitoringPreferences,
  );

  const isEnabled = () => {
    if ('Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window)
      return Notification.permission;

    return undefined;
  };

  const [tradingKeywordsList, setTradingKeywordsList] = useState<Array<TradingKeywordTypes>>([]);
  const [keyword, setKeyword] = useState<string>('');
  const [messageNotification, setMessageNotification] = useState<boolean>(false);
  const [emailNotification, setEmailNotification] = useState<boolean>(false);
  const [pushSoundEnabled, setPushSoundEnabled] = useState<boolean>(false);
  const [pushPreferenceEnabled, setPushPreferenceEnabled] = useState<boolean>(false);
  const [receiveNotificationFromAllMessages, setReceiveNotificationFromAllMessages] =
    useState<boolean>(true);
  const [pushEnabled] = useState<string | undefined>(isEnabled());
  const [currentMonitoringPreferences, setCurrentMonitoringPreferences] =
    useState<MonitoringPreferenceData | null>(null);
  const [monitoringNotificationModalOpened, setMonitoringNotificationModalOpened] =
    useState<boolean>(false);

  const getOrCreateMonitoringPreferences = () => {
    if (
      !profile.representant ||
      (profile.representant && profile.clientId === profile.currentCompany[tabId()])
    )
      dispatch(getMonitoringPreferences());
    if (profile.representant && profile.currentCompany[tabId()] !== profile.clientId)
      dispatch(getMonitoringPreferences(profile.currentCompany[tabId()]));
  };

  useEffect(() => {
    getOrCreateMonitoringPreferences();
  }, []);

  useEffect(() => {
    getOrCreateMonitoringPreferences();
  }, [profile.currentCompany[tabId()]]);

  useEffect(() => {
    if (monitoring_preferences === undefined || monitoring_preferences?.length === 0) return;
    if (!profile.representant) setCurrentMonitoringPreferences(monitoring_preferences[0]);

    const preference = monitoring_preferences?.find(
      (preference) => preference.client_id === profile.currentCompany[tabId()],
    );

    if (!preference) return;
    if (profile.representant) setCurrentMonitoringPreferences(preference);
  }, [monitoring_preferences, profile.currentCompany[tabId()]]);

  useEffect(() => {
    if (!currentMonitoringPreferences) return;

    setMessageNotification(currentMonitoringPreferences?.message_notification);
    setEmailNotification(currentMonitoringPreferences?.email_notification);
    setPushSoundEnabled(currentMonitoringPreferences?.sound_notification);
    setPushPreferenceEnabled(currentMonitoringPreferences?.push_notification);
    setReceiveNotificationFromAllMessages(
      currentMonitoringPreferences?.receive_notification_from_all_messages,
    );
  }, [currentMonitoringPreferences]);

  useEffect(() => {
    if (!monitoring.trading_keywords[companyId(profile)]) {
      setTradingKeywordsList([]);
      return;
    }
    setTradingKeywordsList(monitoring.trading_keywords[companyId(profile)]);
  }, [monitoring.trading_keywords]);

  useEffect(() => {
    document.title = 'Configurações do Monitorar Chat - ConLicitação';

    dispatch(getTradingKeywords(companyId(profile)));
  }, []);

  useEffect(() => {
    document.title = 'Configurações do Monitorar Chat - ConLicitação';

    dispatch(getTradingKeywords(companyId(profile)));
  }, [profile.currentCompany[tabId()]]);

  const toggleMonitoringPreference = (notification_type: string) => {
    if (!currentMonitoringPreferences) return;
    dispatch(updateMonitoringPreferences(currentMonitoringPreferences?.id, notification_type));
  };

  return (
    <Container>
      <div className="page-container">
        <div className="container p-4">
          <div className="row mb-3">
            <div className="col-12">
              <Link to="/facilitadores/monitoramento">
                <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar para o
                Monitorar Chat
              </Link>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-12">
              <h4>Configurações do Monitorar Chat</h4>
              <div className="card shadow">
                <div className="card-body">
                  <div className="tour-monitoring-keywords">
                    <label htmlFor="addKeywords">
                      Adicionar palavras-chave para o Monitorar Chat
                    </label>
                    <div className="row">
                      <div className="col-md col-12">
                        <input
                          id="addKeywords"
                          type="text"
                          placeholder="Digite a palavra"
                          className="form-control"
                          onChange={(event) => setKeyword(event.target.value)}
                          value={keyword}
                        />
                        <SquareLoader
                          customClass={
                            request.save_trading_keywords.loading ? 'visible' : 'invisible'
                          }
                        />
                      </div>
                      <div className="col-md-auto col-12 pl-md-0 pl-3 mt-2 mt-md-0">
                        <button
                          type="button"
                          disabled={!keyword}
                          className="btn btn-primary btn-block"
                          onClick={() => {
                            dispatch(saveTradingKeywords(keyword.trim(), companyId(profile)));
                            setKeyword('');
                          }}
                        >
                          Adicionar
                        </button>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12">
                        Palavras-chave monitoradas
                        {request.get_trading_keywords.loading && <Loader />}
                        {request.get_trading_keywords.loaded &&
                          tradingKeywordsList?.length === 0 && (
                            <div className="alert alert-secondary text-center mt-1 mb-1">
                              Você ainda não tem palavras-chave adicionadas. Adicione no campo a
                              cima.
                            </div>
                          )}
                        {request.get_trading_keywords.loaded && tradingKeywordsList?.length > 0 && (
                          <div className="d-flex flex-wrap mt-1">
                            {tradingKeywordsList?.map((tradingKeyword) => (
                              <TradingKeywordItem
                                key={tradingKeyword.id}
                                keyword={tradingKeyword.keyword}
                                deleteKeyword={() =>
                                  dispatch(
                                    deleteTradingKeyword(tradingKeyword.id, companyId(profile)),
                                  )
                                }
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="tour-monitoring-notifications">
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="mb-1 d-flex align-items-center">Notificação de Mensagens</p>
                        <Switch
                          handleChange={() => toggleMonitoringPreference('message_notification')}
                          checked={messageNotification}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="mb-1"> Tipo de Notificação</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 d-flex align-items-center mb-1">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => toggleMonitoringPreference('email_notification')}
                          label="Email"
                          checked={emailNotification}
                          disabled={!messageNotification}
                        />
                        <span
                          className="ml-1 databalloon monitoring-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Você receberá o email quando o chat do pregão tiver a primeira mensagem do dia."
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-flex align-items-center">
                        <Checkbox
                          customClass="m-0"
                          handleChange={() => toggleMonitoringPreference('sound_notification')}
                          label="Aviso Sonoro"
                          checked={pushSoundEnabled}
                          disabled={!messageNotification}
                        />
                        <span
                          className="ml-1 databalloon monitoring-help-mark d-inline-block rounded-circle bg-primary text-white"
                          data-balloon-length="large"
                          aria-label="Para o aviso sono funcionar você precisa estar com o Conlicitação aberto em uma aba do seu navegador."
                          data-balloon-pos="up"
                        >
                          <i className="oi oi-question-mark" />
                        </span>
                      </div>
                      <div className="col-12 d-md-flex d-block align-items-center">
                        <Checkbox
                          customClass="mr-2"
                          handleChange={() => toggleMonitoringPreference('push_notification')}
                          label="Notificação na área de trabalho (Push notification)"
                          checked={pushPreferenceEnabled}
                          disabled={!messageNotification}
                        />
                        {pushEnabled === 'granted' ? (
                          <div role="alert" className="alert alert-success p-1 m-0">
                            O push em seu navegador está ativado.
                          </div>
                        ) : (
                          <div role="alert" className="alert alert-warning p-1 m-0">
                            As notificações estão desativadas.{' '}
                            <a
                              className="p-0 alert-link"
                              data-toggle="modal"
                              data-target="#push-modal"
                              onClick={() => {
                                setMonitoringNotificationModalOpened(true);
                              }}
                              href="#"
                            >
                              Clique para ativar.
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="mb-1">Receber notificações de</p>
                        <div className="form-check form-check-inline mr-5">
                          <input
                            disabled={!messageNotification}
                            className="form-check-input"
                            type="radio"
                            name="pushRadioOptions"
                            id="pushRadioAll"
                            onChange={() =>
                              toggleMonitoringPreference('receive_notification_from_all_messages')
                            }
                            checked={receiveNotificationFromAllMessages}
                          />
                          <label className="form-check-label" htmlFor="pushRadioAll">
                            Todas as mensagens do chat
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            disabled={!messageNotification}
                            className="form-check-input"
                            type="radio"
                            name="pushRadioOptions"
                            id="pushRadioKeyword"
                            onChange={() =>
                              toggleMonitoringPreference('receive_notification_from_all_messages')
                            }
                            checked={!receiveNotificationFromAllMessages}
                          />
                          <label className="form-check-label" htmlFor="pushRadioKeyword">
                            Somente mensagens com palavra-chave
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MonitoringPushModal
        pushEnabled={pushEnabled}
        monitoringNotificationModalOpened={monitoringNotificationModalOpened}
        setMonitoringNotificationModalOpened={setMonitoringNotificationModalOpened}
      />
    </Container>
  );
};

export default MonitoringConfiguration;
